export enum ETabActiveKeyContent {
  DOCUMENTS = '1',
  CONVERSION = '2',
}
